import { i18nMark } from 'lingui-react';

const messages = {
  description: i18nMark('The cases page of the application'),
  title: i18nMark('The Cases Page'),
  defaultHeader: i18nMark('Cases'),
  allRepairCases: i18nMark('All Repair Cases'),
  downtime2Days: i18nMark('Downtime > 2 Days'),
  pastDueFollowUp: i18nMark('Past Due Follow Up'),
  pastDueEtr: i18nMark('Past Due ETR'),
  current: i18nMark('Current'),
  uptimeCases: i18nMark('Uptime Cases'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/CasesPage/messages.js